import {useEffect, useState} from "react";
import baseUrl from "../../../baseUrl";
import {requester} from "../../../services/requester";

export const CropsManager = () => {
    const request = requester();
    const [crops, setCrops] = useState([]);
    const [error, setError] = useState('');
    const [newCrop, setNewCrop] = useState({crop: '', code: ''});
    const [editId, setEditId] = useState(null);
    const [editName, setEditName] = useState('');

    const load = async () => {
        try {
            setError('');
            const data = await request.get(`${baseUrl()}/crops`);
            setCrops([...data].sort((a, b) => a.code - b.code));
        } catch (err) { setError(err.message || 'Грешка при зареждане.'); }
    };

    useEffect(() => {
        load();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const add = async () => {
        try {
            setError('');
            await request.post(`${baseUrl()}/admin/crops`,
                {crop: newCrop.crop.trim(), code: Number(newCrop.code)});
            setNewCrop({crop: '', code: ''});
            load();
        } catch (err) { setError(err.message || 'Грешка при добавяне.'); }
    };

    const saveRename = async (id) => {
        try {
            setError('');
            await request.put(`${baseUrl()}/admin/crops/${id}`, {crop: editName.trim()});
            setEditId(null);
            load();
        } catch (err) { setError(err.message || 'Грешка при преименуване.'); }
    };

    return (
        <div>
            {error && <div className="alert alert-danger">{error}</div>}

            <table className="table table-sm align-middle" style={{maxWidth: '520px'}}>
                <thead>
                <tr><th style={{width: '90px'}}>Код</th><th>Култура</th><th></th></tr>
                </thead>
                <tbody>
                {crops.map(c => (
                    <tr key={c.id}>
                        <td>{c.code}</td>
                        <td>
                            {editId === c.id
                                ? <input className="form-control form-control-sm" value={editName}
                                         onChange={e => setEditName(e.target.value)}/>
                                : c.crop}
                        </td>
                        <td className="text-end">
                            {editId === c.id
                                ? (
                                    <>
                                        <button className="btn btn-sm btn-primary py-0" onClick={() => saveRename(c.id)}>Запис</button>
                                        <button className="btn btn-sm btn-outline-secondary py-0 ms-1" onClick={() => setEditId(null)}>Отказ</button>
                                    </>
                                )
                                : <button className="btn btn-sm btn-outline-secondary py-0"
                                          onClick={() => { setEditId(c.id); setEditName(c.crop); }}>Преименувай</button>}
                        </td>
                    </tr>
                ))}
                <tr>
                    <td>
                        <input className="form-control form-control-sm" placeholder="код" type="number"
                               value={newCrop.code} onChange={e => setNewCrop(p => ({...p, code: e.target.value}))}/>
                    </td>
                    <td>
                        <input className="form-control form-control-sm" placeholder="нова култура"
                               value={newCrop.crop} onChange={e => setNewCrop(p => ({...p, crop: e.target.value}))}/>
                    </td>
                    <td className="text-end">
                        <button className="btn btn-sm btn-success py-0"
                                disabled={!newCrop.crop.trim() || !newCrop.code} onClick={add}>+ Добави</button>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
    );
};
